import { render, staticRenderFns } from "./SystemLoadChart.vue?vue&type=template&id=923a7e16&"
import script from "./SystemLoadChart.vue?vue&type=script&lang=ts&"
export * from "./SystemLoadChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports